import { render, staticRenderFns } from "./Putts.vue?vue&type=template&id=75415abc&"
import script from "./Putts.vue?vue&type=script&lang=js&"
export * from "./Putts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports